import { render } from "./codeLogin.vue?vue&type=template&id=61c10fbf&scoped=true"
import script from "./codeLogin.vue?vue&type=script&lang=js"
export * from "./codeLogin.vue?vue&type=script&lang=js"

import "./codeLogin.vue?vue&type=style&index=0&id=61c10fbf&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c10fbf"]])

export default __exports__